export async function shareToNative({ canvas, text }) {
  // Convert canvas → blob → file
  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, "image/png")
  );

  const file = new File([blob], "uflix-story.png", {
    type: "image/png",
  });

  // ✅ Native Share (mobile)
 if (
    navigator.share &&
    navigator.canShare &&
    navigator.canShare({ files: [file] })
  ) {
    try {
      await navigator.share({
        files: [file],
        text,
      });
    } catch (err) {
      // ✅ NORMAL CASE: user cancel
      if (err.name === "AbortError") {
        console.log("User canceled share");
        return;
      }

      // ❌ Real error
      console.error("Share failed:", err);
      alert("Failed to open share menu");
    }
    return;
  }


  // ❌ Fallback: download
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "uflix-story.png";
  a.click();
  URL.revokeObjectURL(url);

  alert("Download image lalu share ke Instagram Story 📸");
}
